<template>
  <SendQuestionnaire @sent="openDoneModal = true" />
  <DoneModal
    :open-dialog="openDoneModal"
    :text="'The questionnaire was successfully sent.'"
    @close-dialog="routeAfterDone"
  />
</template>

<script setup lang="ts">
import { ref } from "vue";
import SendQuestionnaire from "./SendQuestionnaire.vue";
import DoneModal from "@/components/questionnaire/DoneModal.vue";
import { RouterPath } from "@/models/enum/routerPath";
import router from "@/router";

const openDoneModal = ref(false);

function routeAfterDone() {
  router.push(RouterPath.Questionnaires);
}
</script>
